export default __webpack_public_path__ + "static/media/municipalidades.04fb29ca.svg";